import { translate } from 'services/i18nService';
import { Theme } from 'themes/themes.types';

import diceIcon from './images/games/dice-icon.png';
import kenoIcon from './images/games/keno-icon.png';
import wheelIcon from './images/games/wheel-icon.png';
import logoImage from './images/logo.png';
import boostIcon from './images/boost/boost-icon.png';
import boostButtonIcon from './images/boost/boost-button-icon.png';
import boostSound from './sounds/boost/boost.mp3';
import tippingTier1Sound from './sounds/tipping/tip_tier_1.mp3';
import tippingTier2Sound from './sounds/tipping/tip_tier_2.mp3';
import tippingTier3Sound from './sounds/tipping/tip_tier_3.mp3';
import tippingTier4Sound from './sounds/tipping/tip_tier_4.mp3';
import styles from './DefaultTheme.css';


export default abstract class DefaultTheme {
  static get theme(): Theme {
    return {
      games: {
        keno: {
          icon: kenoIcon,
          borderClass: styles.kenoBorder,
          containerClass: styles.kenoContainer,
        },
        wheel: {
          icon: wheelIcon,
          containerClass: styles.wheelContainer,
          outerCircleClass: styles.wheelOuterCircle,
          arrowClass: styles.wheelArrow,
          centerClass: styles.wheelCenter,
        },
        dice: {
          icon: diceIcon,
          containerClass: styles.diceContainer,
        },
      },
      logoImage,
      boost: {
        icon: boostIcon,
        buttonIcon: boostButtonIcon,
        modalTitle: translate('profile.boost.stream'),
        timerLabel: translate('profile.boost.boost') as string,
        sound: boostSound,
      },
      tipping: {
        tier1Sound: tippingTier1Sound,
        tier2Sound: tippingTier2Sound,
        tier3Sound: tippingTier3Sound,
        tier4Sound: tippingTier4Sound,
      },
    };
  }
}

